import type { ColDef, ICellRendererParams } from "ag-grid-enterprise";
import { Box, IconButton, Tooltip } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import type { RollBlank } from "../models/RollBlank";
import { activeColumnDef } from "@/controls/ag-grid/components/ActiveColumn";

interface UseTableDataProps {
	onDelete: (blank: RollBlank) => void;
}

export const useTableData = ({ onDelete }: UseTableDataProps) => {
	const columnDefs: ColDef<RollBlank>[] = [
		{
			field: "Dwg",
			headerName: "Name",
			flex: 1.5,
			sortable: true,
			filter: true,
		},
		{
			field: "Description",
			headerName: "Description",
			flex: 2,
			sortable: true,
			filter: true,
		},
		{
			field: "MillSizeName",
			headerName: "Mill Size",
			flex: 0.7,
			sortable: true,
		},
		{
			field: "Width",
			headerName: "Width",
			flex: 0.7,
			valueFormatter: (params: { value: number | null }) =>
				params.value != null ? params.value.toFixed(2) : "",
		},
		{
			field: "NewDiameter",
			headerName: "New Diam",
			flex: 0.7,
			valueFormatter: (params: { value: number | null }) =>
				params.value != null ? params.value.toFixed(2) : "",
		},
		{
			field: "ScrapDiameter",
			headerName: "Scrap Diam",
			flex: 0.7,
			valueFormatter: (params: { value: number | null }) =>
				params.value != null ? params.value.toFixed(3) : "",
		},
		{
			field: "RollApplicationName",
			headerName: "Roll App",
			flex: 1.3,
			sortable: true,
		},
		{
			field: "RollMaterialName",
			headerName: "Roll Mat",
			flex: 1.3,
			sortable: true,
		},
		activeColumnDef<RollBlank>(),
		{
			headerName: "",
			width: 60,
			minWidth: 60,
			maxWidth: 60,
			sortable: false,
			filter: false,
			resizable: false,
			suppressSizeToFit: true,
			cellRenderer: (params: ICellRendererParams<RollBlank>) => {
				if (!params.data) return null;
				return (
					<Box
						sx={{
							display: "flex",
							justifyContent: "center",
							alignItems: "center",
							height: "100%",
						}}
					>
						<Tooltip title="Delete">
							<IconButton
								size="small"
								onClick={(e) => {
									e.stopPropagation();
									onDelete(params.data as RollBlank);
								}}
								color="error"
							>
								<DeleteIcon fontSize="small" />
							</IconButton>
						</Tooltip>
					</Box>
				);
			},
		},
	];

	return { columnDefs };
};
